var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "co-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.closeWindow.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "section",
        {
          staticClass: "co-dialog",
          attrs: {
            id: "confirmOrderWindow",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.$t("purchase_confirm_text"),
          },
        },
        [
          _c("div", { staticClass: "co-header" }, [
            _c("h3", { staticClass: "co-title" }, [
              _vm._v(_vm._s(_vm.$t("purchase_confirm_text"))),
            ]),
            _c(
              "button",
              {
                staticClass: "co-close",
                attrs: { type: "button", "aria-label": _vm.$t("close_text") },
                on: { click: _vm.closeWindow },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
          ]),
          _c("div", { staticClass: "co-body" }, [
            _c(
              "section",
              { staticClass: "co-order-summary co-checkout-module" },
              [
                _c("div", { staticClass: "co-role-row" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "co-role-copy" }, [
                    _c("strong", { staticClass: "co-role-name" }, [
                      _vm._v(_vm._s(_vm.roleInfo.roleName)),
                    ]),
                    _c("span", { staticClass: "co-role-meta" }, [
                      _vm._v("ID: " + _vm._s(_vm.roleInfo.roleId)),
                      _c("span", { staticClass: "co-sep" }, [_vm._v("·")]),
                      _vm._v(_vm._s(_vm.roleInfo.serverName)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "co-product-row" }, [
                  _c("div", { staticClass: "co-product-main" }, [
                    _c("div", { staticClass: "co-product-icon-wrap" }, [
                      _vm.goods.icon
                        ? _c("img", {
                            staticClass: "co-product-icon",
                            attrs: {
                              src: _vm.goods.icon,
                              alt: _vm.goods.tips || "",
                            },
                          })
                        : _c("i", {
                            staticClass:
                              "fa fa-ticket co-product-icon-fallback",
                            attrs: { "aria-hidden": "true" },
                          }),
                    ]),
                    _c("div", { staticClass: "co-product-text" }, [
                      _c("strong", { staticClass: "co-product-name" }, [
                        _vm._v(_vm._s(_vm.goods.tips)),
                      ]),
                      _vm.goods.points > 0
                        ? _c("span", { staticClass: "co-product-pts" }, [
                            _vm._v(
                              _vm._s(_vm.$t("earn_points_text")) +
                                ": " +
                                _vm._s(_vm.goods.points)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "co-product-price-area" }, [
                    _c("strong", { staticClass: "co-product-price" }, [
                      _vm._v(
                        _vm._s(_vm.goods.currency) +
                          " " +
                          _vm._s(_vm.formatMoney(_vm.goods.amount))
                      ),
                    ]),
                    _vm.finalRebate > 0
                      ? _c("span", { staticClass: "co-rebate-note" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.rebate.mode == 3
                                  ? _vm.$t("rebate_limited_text", {
                                      pct: _vm.finalRebate,
                                    })
                                  : _vm.$t("rebate_percent_text", {
                                      pct: _vm.finalRebate,
                                    })
                              ) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            !_vm.checkoutReady || _vm.displayCoupons.length > 0
              ? _c(
                  "section",
                  {
                    staticClass:
                      "co-section co-coupon-section co-checkout-module",
                    attrs: { "aria-busy": !_vm.checkoutReady },
                  },
                  [
                    !_vm.checkoutReady
                      ? _c(
                          "div",
                          {
                            staticClass: "co-coupon-skeleton",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("span", {
                              staticClass:
                                "co-skeleton-shape co-skeleton-line co-skeleton-coupon-label",
                            }),
                            _c("span", {
                              staticClass:
                                "co-skeleton-shape co-skeleton-value",
                            }),
                            _c("span", {
                              staticClass:
                                "co-skeleton-shape co-skeleton-chevron",
                            }),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "co-coupon-select co-data-ready",
                            class: [
                              {
                                "co-coupon-select-empty":
                                  !_vm.selectedCouponObj,
                              },
                              _vm.selectedCouponObj
                                ? "is-" +
                                  _vm.getCouponKind(_vm.selectedCouponObj)
                                : "",
                            ],
                            attrs: { type: "button" },
                            on: { click: _vm.openCouponPicker },
                          },
                          [
                            _c(
                              "strong",
                              { staticClass: "co-coupon-entry-label" },
                              [
                                _vm._m(1),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("coupon_entry_label"))),
                                ]),
                              ]
                            ),
                            _c("span", { staticClass: "co-coupon-summary" }, [
                              _vm.selectedCouponObj
                                ? _c(
                                    "em",
                                    { staticClass: "co-coupon-kind-tag" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.getCouponKindLabel(
                                              _vm.getCouponKind(
                                                _vm.selectedCouponObj
                                              )
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "co-coupon-value",
                                  class: _vm.selectedCouponObj
                                    ? "is-" +
                                      _vm.getCouponKind(_vm.selectedCouponObj)
                                    : "",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.selectedCouponObj
                                          ? _vm.getCouponValueText(
                                              _vm.selectedCouponObj
                                            )
                                          : _vm.$t("coupon_available_count", {
                                              count:
                                                _vm.availableCoupons.length,
                                            })
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]),
                            _c("i", {
                              staticClass:
                                "fa fa-chevron-right co-coupon-arrow",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                    _vm.showExtraRebateTips
                      ? _c("p", { staticClass: "co-coupon-notice" }, [
                          _vm._v(_vm._s(_vm.$t("coupon_extra_rebate_notice"))),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            !_vm.checkoutReady ||
            _vm.recommendedChannels.length ||
            _vm.otherChannels.length
              ? _c(
                  "section",
                  {
                    staticClass:
                      "co-section co-payment-section co-checkout-module",
                    attrs: { "aria-busy": !_vm.checkoutReady },
                  },
                  [
                    _c("div", { staticClass: "co-section-heading" }, [
                      _c("div", { staticClass: "co-section-title-wrap" }, [
                        _vm._m(2),
                        _c("h4", [
                          _vm._v(_vm._s(_vm.$t("payment_recommended_text"))),
                        ]),
                      ]),
                    ]),
                    !_vm.checkoutReady
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "co-pay-group co-pay-group--recommended co-pay-group-skeleton",
                              attrs: { "aria-hidden": "true" },
                            },
                            _vm._l(3, function (index) {
                              return _c(
                                "div",
                                {
                                  key: "recommended-skeleton-" + index,
                                  staticClass: "co-channel co-channel-skeleton",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "co-skeleton-shape co-skeleton-logo",
                                  }),
                                  _vm._m(3, true),
                                  _c("span", {
                                    staticClass:
                                      "co-skeleton-shape co-skeleton-radio",
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "co-pay-group co-pay-group--other co-pay-group-skeleton",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._m(4),
                              _vm._l(2, function (index) {
                                return _c(
                                  "div",
                                  {
                                    key: "other-skeleton-" + index,
                                    staticClass:
                                      "co-channel co-channel-skeleton",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "co-skeleton-shape co-skeleton-logo",
                                    }),
                                    _vm._m(5, true),
                                    _c("span", {
                                      staticClass:
                                        "co-skeleton-shape co-skeleton-radio",
                                    }),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      : _vm.recommendedChannels.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "co-pay-group co-pay-group--recommended co-data-ready",
                            attrs: {
                              role: "group",
                              "aria-label": _vm.$t("payment_recommended_text"),
                            },
                          },
                          _vm._l(_vm.recommendedChannels, function (item) {
                            return _c(
                              "button",
                              {
                                key: "rec-" + item._idx,
                                staticClass: "co-channel",
                                class: {
                                  "co-channel-on":
                                    _vm.selectedChannel === item._idx,
                                },
                                attrs: {
                                  type: "button",
                                  "aria-pressed":
                                    _vm.selectedChannel === item._idx,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.chooseChannel(item._idx)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "co-ch-icon",
                                  class:
                                    item.iconStyle === "rectangle"
                                      ? "co-ch-rect"
                                      : "co-ch-sq",
                                  attrs: { src: item.icon, alt: item.name },
                                }),
                                _c("span", { staticClass: "co-ch-copy" }, [
                                  _c("span", { staticClass: "co-ch-name" }, [
                                    _vm._v(_vm._s(item.name)),
                                  ]),
                                  _vm.getChannelBenefitText(item)
                                    ? _c(
                                        "span",
                                        { staticClass: "co-ch-benefit" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getChannelBenefitText(item)
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "co-ch-radio",
                                    class: {
                                      on: _vm.selectedChannel === item._idx,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-check",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.checkoutReady && _vm.otherChannels.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "co-pay-group co-pay-group--other co-data-ready",
                            attrs: {
                              role: "group",
                              "aria-label": _vm.$t(
                                "payment_other_methods_text"
                              ),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "co-section-heading co-payment-group-heading co-payment-group-heading--muted",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "co-section-title-wrap" },
                                  [
                                    _vm._m(6),
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("payment_other_methods_text")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._l(_vm.otherChannels, function (item) {
                              return _c(
                                "button",
                                {
                                  key: "other-" + item._idx,
                                  staticClass: "co-channel",
                                  class: {
                                    "co-channel-on":
                                      _vm.selectedChannel === item._idx,
                                  },
                                  attrs: {
                                    type: "button",
                                    "aria-pressed":
                                      _vm.selectedChannel === item._idx,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.chooseChannel(item._idx)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "co-ch-icon",
                                    class:
                                      item.iconStyle === "rectangle"
                                        ? "co-ch-rect"
                                        : "co-ch-sq",
                                    attrs: { src: item.icon, alt: item.name },
                                  }),
                                  _c("span", { staticClass: "co-ch-copy" }, [
                                    _c("span", { staticClass: "co-ch-name" }, [
                                      _vm._v(_vm._s(item.name)),
                                    ]),
                                    _vm.getChannelBenefitText(item)
                                      ? _c(
                                          "span",
                                          { staticClass: "co-ch-benefit" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getChannelBenefitText(item)
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "co-ch-radio",
                                      class: {
                                        on: _vm.selectedChannel === item._idx,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-check",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "co-footer" }, [
            _c("div", { staticClass: "co-price-summary" }, [
              _c("div", { staticClass: "co-price-breakdown" }, [
                _c("span", { staticClass: "co-price-item" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("order_amount_text")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.goods.currency) +
                        " " +
                        _vm._s(_vm.formatMoney(_vm.goods.amount))
                    ),
                  ]),
                ]),
                _vm.selectedDiscountCoupon && _vm.selectedDiscountAmount > 0
                  ? _c(
                      "span",
                      { staticClass: "co-price-item co-price-discount" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("discount_amount_text")) +
                            "\n\t\t\t\t\t\t"
                        ),
                        _c("strong", [
                          _vm._v(
                            "-" +
                              _vm._s(_vm.goods.currency) +
                              " " +
                              _vm._s(
                                _vm.formatMoney(_vm.selectedDiscountAmount)
                              )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "co-total-row" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("payable_amount_text")))]),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.goods.currency) +
                      " " +
                      _vm._s(_vm.formatMoney(_vm.payableAmount))
                  ),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "co-confirm-btn bg_color",
                attrs: {
                  id: "confirmButton",
                  disabled:
                    _vm.buttonDisabled ||
                    !_vm.checkoutReady ||
                    !_vm.currentChannel,
                  type: "button",
                },
                on: { click: _vm.openThirdPaymentPage },
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(_vm.payButtonText) + "\n\t\t\t")]
            ),
          ]),
          _c("transition", { attrs: { name: "co-picker-fade" } }, [
            _vm.showCouponPicker
              ? _c(
                  "div",
                  {
                    staticClass: "co-picker-overlay",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        return _vm.closeCouponPicker.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "co-picker-sheet",
                        attrs: {
                          role: "dialog",
                          "aria-modal": "true",
                          "aria-label": _vm.$t("coupon_picker_title"),
                        },
                      },
                      [
                        _c("div", { staticClass: "co-picker-handle" }),
                        _c("div", { staticClass: "co-picker-header" }, [
                          _c("strong", { staticClass: "co-picker-title" }, [
                            _vm._v(_vm._s(_vm.$t("coupon_picker_title"))),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "co-picker-close",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t("close_text"),
                              },
                              on: { click: _vm.closeCouponPicker },
                            },
                            [_vm._v("\n\t\t\t\t\t\t\t×\n\t\t\t\t\t\t")]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "co-picker-tabs",
                            attrs: {
                              role: "tablist",
                              "aria-label": _vm.$t("coupon_picker_title"),
                            },
                          },
                          _vm._l(_vm.couponKindTabs, function (tab) {
                            return _c(
                              "button",
                              {
                                key: tab.kind,
                                staticClass: "co-picker-tab",
                                class: [
                                  "is-" + tab.kind,
                                  {
                                    "is-active":
                                      _vm.activeCouponKind === tab.kind,
                                    "has-selection":
                                      _vm.selectedCouponKind === tab.kind,
                                  },
                                ],
                                attrs: {
                                  type: "button",
                                  role: "tab",
                                  disabled: tab.count === 0,
                                  "aria-selected":
                                    _vm.activeCouponKind === tab.kind,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActiveCouponKind(tab.kind)
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(tab.label))]),
                                _c("small", [_vm._v(_vm._s(tab.count))]),
                              ]
                            )
                          }),
                          0
                        ),
                        _c(
                          "div",
                          { staticClass: "co-picker-list" },
                          _vm._l(_vm.couponPickerGroups, function (group) {
                            return _c(
                              "section",
                              {
                                key: group.key,
                                staticClass: "co-picker-group",
                                class: {
                                  "co-picker-group--unavailable":
                                    group.disabled,
                                },
                              },
                              [
                                group.disabled
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "co-picker-unavailable-toggle",
                                        attrs: {
                                          type: "button",
                                          "aria-expanded":
                                            _vm.showUnavailableCoupons,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.showUnavailableCoupons =
                                              !_vm.showUnavailableCoupons
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("coupon_unavailable_title")
                                            )
                                          ),
                                        ]),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(group.items.length) +
                                              _vm._s(
                                                _vm.$t("coupon_count_unit")
                                              )
                                          ),
                                        ]),
                                        _c("i", {
                                          class: _vm.showUnavailableCoupons
                                            ? "fa fa-caret-up"
                                            : "fa fa-caret-down",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !group.disabled ||
                                          _vm.showUnavailableCoupons,
                                        expression:
                                          "!group.disabled || showUnavailableCoupons",
                                      },
                                    ],
                                    staticClass: "co-picker-group-list",
                                  },
                                  _vm._l(group.items, function (item) {
                                    return _c(
                                      "button",
                                      {
                                        key: item.couponId,
                                        staticClass: "co-picker-row",
                                        class: [
                                          "co-picker-row--" +
                                            _vm.activeCouponKind,
                                          {
                                            "co-picker-row-on":
                                              _vm.isCouponSelected(item),
                                            "co-picker-row-disabled":
                                              group.disabled,
                                          },
                                        ],
                                        attrs: {
                                          type: "button",
                                          disabled: group.disabled,
                                          "aria-pressed":
                                            _vm.isCouponSelected(item),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectCoupon(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "co-picker-check",
                                          class: {
                                            on: _vm.isCouponSelected(item),
                                            "is-disabled": group.disabled,
                                          },
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "co-picker-row-info" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.getCouponLabel(item))
                                              ),
                                              _vm.isBestCoupon(item)
                                                ? _c(
                                                    "em",
                                                    {
                                                      staticClass:
                                                        "co-picker-best-tag",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "coupon_best_tag"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getCouponPickerHint(item)
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "co-picker-value",
                                            class: "is-" + _vm.activeCouponKind,
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getCouponValueText(item)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "co-role-avatar", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "fa fa-user" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "co-coupon-entry-icon", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "fa fa-gift" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "co-section-icon", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "fa fa-star" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "co-skeleton-channel-copy" }, [
      _c("span", {
        staticClass:
          "co-skeleton-shape co-skeleton-line co-skeleton-channel-name",
      }),
      _c("span", {
        staticClass: "co-skeleton-shape co-skeleton-line co-skeleton-benefit",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "co-section-heading co-payment-group-heading co-payment-group-heading--muted",
      },
      [
        _c("div", { staticClass: "co-section-title-wrap" }, [
          _c("span", { staticClass: "co-section-icon" }, [
            _c("i", { staticClass: "fa fa-credit-card" }),
          ]),
          _c("span", {
            staticClass: "co-skeleton-shape co-skeleton-group-title",
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "co-skeleton-channel-copy" }, [
      _c("span", {
        staticClass:
          "co-skeleton-shape co-skeleton-line co-skeleton-channel-name",
      }),
      _c("span", {
        staticClass: "co-skeleton-shape co-skeleton-line co-skeleton-benefit",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "co-section-icon", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "fa fa-credit-card" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }